// extracted by mini-css-extract-plugin
module.exports = {"emptyGroup":"empty-group_emptyGroup__3JlWe","content":"empty-group_content__z29uv"};